import { baseUrl as apiBaseUrl } from '../../config/appsettings';

const baseUrl = apiBaseUrl + 'Analytics';

const AnalyticsApiService = {
  // Fetch all analytics records
  getAllWebAnalytics: async () => {
    try {
      const response = await fetch(`${baseUrl}/GetWebAnalytics`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching analytics data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  getAllAppAnalytics: async () => {
    try {
      const response = await fetch(`${baseUrl}/GetAppAnalytics`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching analytics data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

   GetAnalyticsForGraph: async (userId, graphType) => {
    try {
        const response = await fetch(`${baseUrl}/GetAnalyticsForGraph`, {
            method: 'POST', // Changed to POST assuming request needs a body
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                userId: userId, 
                GraphType: graphType
            }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error fetching analytics data');
        }

        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw new Error('Network error');
    }
},
  // Add a new analytics record
  addAnalytics: async (analyticsData) => {
    try {
      const response = await fetch(`${baseUrl}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(analyticsData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error adding analytics data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  // Fetch a single analytics record by ID
  getById: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Analytics record not found');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  GetUserWebAnalytics: async (id) => {
    try {
        const response = await fetch(`${baseUrl}/GetUserWebAnalytics/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Analytics record not found');
        }

        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw new Error('Network error');
    }
},
GetUserAppAnalytics: async (id) => {
    try {
        const response = await fetch(`${baseUrl}/GetUserAppAnalytics/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Analytics record not found');
        }

        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        throw new Error('Network error');
    }
},


  

  // Update an existing analytics record by ID
  updateAnalytics: async (id, analyticsData) => {
    try {
      const response = await fetch(`${baseUrl}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(analyticsData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error updating analytics data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  updateAppAnalytics: async (id, analyticsData) => {
    try {
      const response = await fetch(`${baseUrl}/UpdateAppAnalytics/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(analyticsData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error updating analytics data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  // Delete an analytics record by ID
  deleteAnalytics: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/WebDelete/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error deleting analytics data');
      }

      return true; // Return true on successful deletion
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  deleteAppAnalytics: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/AppDelete/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error deleting analytics data');
      }

      return true; // Return true on successful deletion
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  // Get publisher revenue by date range
  getPublisherRevenueByDateRange: async (userId, fromDate, toDate) => {
    try {
      const response = await fetch(`${baseUrl}/GetPublisherRevenue`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: userId,
          fromDate: fromDate,
          toDate: toDate
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching revenue data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
};

export default AnalyticsApiService;
